import {Injectable} from '@angular/core';
import {RailingLightArrangeService} from './railing-light-arrange.service';
import {Subject} from 'rxjs/Subject';

declare const THREE: any;

type Added = {lightMesh: any} & Pick<Feeney.Rail.IRail, 'verticalPosition'>;

@Injectable()
export class RailLightAppendService {

  readonly onAdded = new Subject<Added>();

  constructor(
    private lightArrange: RailingLightArrangeService
  ) {
  }

  addLightToRail(railInfo: Feeney.Rail.IRail) {

    const {rail, startPoint, endPoint, isHorizontal} = railInfo;
    const {width: railWidth, height: railHeight} = rail.userData.entity;
    const lightMeshSize = {width: railWidth / 4, height: 1};

    const verticalOffset = railInfo.verticalOffset || 0;
    const halfOfLightMeshHeight = lightMeshSize.height / 2;

    let rayInfo, floorOffset: number;
    if (!isHorizontal) {
      const railMesh = rail.children[0];
      railMesh.updateMatrixWorld();
      const railLength = startPoint.distanceTo(endPoint);
      const railSidePoint = railMesh.localToWorld(new THREE.Vector3(-railLength / 2, -railHeight / 2, 0));
      const railDirection = endPoint.clone().sub(startPoint.clone().setY(endPoint.y)).normalize();
      const horizontalRotationAxis = railDirection.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), THREE.Math.degToRad(90));
      const railDirectionWithVerticalRotation = railDirection.clone().applyAxisAngle(horizontalRotationAxis, -rail.rotation.z);
      rayInfo = new THREE.Ray(railSidePoint, railDirectionWithVerticalRotation);
      floorOffset = -halfOfLightMeshHeight;
    } else {
      floorOffset = rail.userData.entity.placementHeight + verticalOffset - halfOfLightMeshHeight;
    }

    const lightMeshes = this.lightArrange.arrange({
      pointA: startPoint,
      pointB: endPoint,
      lightMeshSize,
      floorOffset,
      rayInfo
    });

    rail.updateMatrixWorld();

    lightMeshes.forEach(o => {
      rail.worldToLocal(o.position);
      rail.add(o);
      this.onAdded.next({
        lightMesh: o,
        verticalPosition: railInfo.verticalPosition
      });
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/services/railing/light/rail-light-append.service.ts